import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
// import Axios from 'axios';
import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import "./market-menu.scss"

const   MarketMenu = ({ mobile, activeCarrito, setActiveCarrito }) => {
  var resultQuery = useStaticQuery(
    graphql`
      query MARKET_CONSULTING {
        allContentfulNolHomeTercerNivel(filter: { slug: { eq: "tiendas" } }) {
          nodes {
            node_locale
            promocionesDeProductos {
              imagen {
                file {
                  url
                }
                description
              }
              descripcion {
                raw
              }
              ciudades {
                nombre
              }
            }

            comercios {
              imagen {
                description
                file {
                  url
                }
              }
              redireccion
              ciudades {
                nombre
              }
            }
            titulo
            subtituloGeneral {
              subtituloGeneral
            }
          }
        }
      }
    `
  )
  const [promocion] = useState(
    resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
      e => e.node_locale === process.env.LOCALE
    )[0].promocionesDeProductos
  )
  const [comercio] = useState(
    resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
      e => e.node_locale === process.env.LOCALE
    )[0].comercios
  )
  var settings = {
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    dots: !!mobile,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 1000,
  }
  var settings2 = {
    infinite: false,
    slidesToShow: comercio.length > 3 ? 3 : comercio.length,
    dots: !!mobile,
    slidesToScroll: 1,
  }

  useEffect(() => {
    // Actualiza el título del documento usando la API del navegador
    // navigator.geolocation.getCurrentPosition(pos => {
    //     var cityAux;
    //     Axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + pos.coords.latitude + "," + pos.coords.longitude + "&key=AIzaSyCN8ZrJwdNr5hJ4FkpgwMR6qzH1KS4TWlg").then(resp => {
    //         var results = resp.data.results;
    //         for (var j = 0; j < results.length; j++) {
    //             if (results[j].types[0] === 'locality') {
    //                 break;
    //             }
    //         }
    //         for (var i = 0; i < results[j].address_components.length; i++) {
    //             if (results[j].address_components[i].types[0] === "locality") {
    //                 //this is the object you are looking for City
    //                 cityAux = results[j].address_components[i];
    //             }
    //             // if (results[j].address_components[i].types[0] === "country") {
    //             //     //this is the object you are looking for
    //             //     countryAux = results[j].address_components[i];
    //             // }
    //         }
    //         setPromocion(promocion.filter((info) =>
    //             info.ciudades.find(({ nombre }) => nombre.toLowerCase() === cityAux.long_name.toLowerCase())
    //         ))
    //         setComercio(comercio.filter((info) =>
    //             info.ciudades.find(({ nombre }) => nombre.toLowerCase() === cityAux.long_name.toLowerCase())
    //         ))
    //         //city data
    //         // alert(city.long_name + " || " + country.short_name)
    //     })
    // }, () => console.log("error"))
  }, [])

  return (
    <div className="f-MarketMenu">
      {activeCarrito && (
        <div
          className="f-close-colapse"
          onClick={() => setActiveCarrito(false)}
        ></div>
      )}
      <span className="f-MarketMenu-tooltip"></span>
      <div>
        {promocion.length > 0 && (
          <Slider {...settings} className="f-MarketMenu-slider-promo">
            {promocion.map((prom, index) => {
              return (
                // defaultChecked = { activeFilters.find(x => x.id === numfilter + index) ? activeFilters.find(x => x.id === numfilter + index).value : false }

                <div key={index}>
                  <div className="f-MarketMenu-slider-promo-content">
                    <img
                      alt={prom.imagen[0].description}
                      src={prom.imagen[0].file.url}
                    />
                    {documentToReactComponents(prom.descripcion.json)}
                  </div>
                </div>
              )
            })}
          </Slider>
        )}
      </div>
      <div className="f-MarketMenu-content">
        <h3 className="f-MarketMenu-content-title">
          {process.env.LOCALE === "es-AR" ? "Tienda Online" : "Tienda"}
        </h3>
        <p>
          {
            resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
              e => e.node_locale === process.env.LOCALE
            )[0].subtituloGeneral.subtituloGeneral
          }
        </p>
        {comercio.length > 0 && (
          <Slider {...settings2} className="f-MarketMenu-slider-comercio">
            {comercio.map((item, index) => {
              return (
                // defaultChecked = { activeFilters.find(x => x.id === numfilter + index) ? activeFilters.find(x => x.id === numfilter + index).value : false }

                <div key={index}>
                  <div className="f-MarketMenu-slider-comercio-content">
                    <a
                      href={item.redireccion}
                      rel="noopener noreferrer"
                      target="_blank"
                    >
                      <img
                        alt={item.imagen[0].description}
                        src={item.imagen[0].file.url}
                      />
                    </a>
                  </div>
                </div>
              )
            })}
          </Slider>
        )}
      </div>
    </div>
  )
}

export default MarketMenu
